/**
* tailwind plugins was written using extend configuration feature. It was used to give our modal sizes into the existing config.

* ? https://tailwindcss.com/docs/plugins#extending-the-configuration
*/
import plugin from 'tailwindcss/plugin'

export default plugin(
  ({ matchUtilities, theme }) => {
    matchUtilities(
      {
        'drawer-size': (value) => ({
          maxWidth: value,
        }),
      },
      { values: theme('drawerSize') },
    )
  },
  {
    theme: {
      drawerSize: {
        sm: '480px',
        md: '600px',
        lg: '720px',
        xl: '1088px',
      },
    },
  },
)
